module.exports = __webpack_public_path__ + "img/syukyaku-sytem-002.d2b87039.jpg";